import StoreAppEvents from './vendors/storeapp';
import BOOMR from './vendors/boomerang';
import Ensighten from './vendors/ensighten';
import Facebook from './vendors/facebook';
import MoxieConcierge from './vendors/moxie-concierge';
import Turn from './vendors/turn';
import UDL_API from './vendors/udl';

const config = {
    vendors: [
        {
            name: 'UDL',
            api: new UDL_API()
        },
        {
            name: 'Ensighten',
            api: new Ensighten()
        },
        {
            name: 'Turn',
            api: new Turn()
        },
        {
            name: 'Facebook',
            api: new Facebook()
        },
        {
            name: 'Boomerange',
            api: new BOOMR(),
        },
        {
            name: 'MoxieConcierge',
            api: new MoxieConcierge(),
        },
        { 
            name: 'StoreAppEvents',
            api: new StoreAppEvents(),
        }
    ],
    pageViewEvent: "pageLoad",
    debug: false,
};

const devConfig = {
    vendors: [
        { 
            name: 'StoreAppEvents',
            api: new StoreAppEvents(),
        },
    ],
    debug: true,
};

let isSelenium, isLocal;
try {
   isSelenium = window.location.search.indexOf('selenium=true') > -1;
   // TODO: we can probably ask Michael's team to ignore tracking from localhost,
   // this way we can still QA tracking on local without worrying about feeding to Adobe/GA
   isLocal = window.location.hostname.indexOf('localhost') > -1 && window.location.search.indexOf('metricsEnabled=true') < 0;
} catch(e) {
    isSelenium = false;
    isLocal = false;
}
const disableMetrics = isSelenium || isLocal;

export default disableMetrics ? devConfig : config;
